module.exports = __webpack_public_path__ + "img/cooperation-way-bg1.d61d3f66.png";